import { render, staticRenderFns } from "./PanelRowItemLink.vue?vue&type=template&id=95c82a30&scoped=true&"
import script from "./PanelRowItemLink.vue?vue&type=script&lang=js&"
export * from "./PanelRowItemLink.vue?vue&type=script&lang=js&"
import style0 from "./PanelRowItemLink.vue?vue&type=style&index=0&id=95c82a30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c82a30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
